import { SupplyModel } from '@pressreader/commerce-types';

enum PurchaseInfoProductTypeDto {
    Subscription = 0,
    Issue = 1,
    Bundle = 2,
}

enum PurchaseInfoSubscriptuionType {
    Personal = 0,
    Business = 1,
}

enum PurchaseInfoPeriodTypeDto {
    Month = 0,
    Day = 1,
}

enum OrderProductTypeDto {
    Subscription = 1,
    Newspaper = 2,
    IRexDeliveryCharge = 3,
    BundleProduct = 4,
}

interface IOrderProductDto {
    ProductId: string;
    Name: string;
    Price: number;
    FormattedPrice: string;
    Type: OrderProductTypeDto;
    IsIssue: boolean;
    IsSubscription: string;
}

interface IBasketDto {
    Total: number;
    FormattedTotal: string;
    Items: IOrderProductDto[];
    PaymentRequired: boolean;
    TaxTotal: number;
    FormattedTaxTotal: string;
    FormattedSubtotal: string;
}

interface IPurchaseContextDto {
    CurrentSubscriptionId: string;
    CurrentSubscriptionHasBalance: boolean;
    BillingInfo: IPurchaseInfoBillingInfoDto;
    Basket: IBasketDto;
    CanCheckout: boolean;
    IsBillingInfoEnabled: boolean;
}

interface IPurchaseInfoPeriodDto {
    Type: PurchaseInfoPeriodTypeDto;
    Value: number;
}

interface IPurchaseInfoPriceDto {
    Currency: string;
    Value: number;
}

interface IPurchaseInfoPromoInfoDto {
    AdjustedPrice?: number;
    AdjustedPriceFormatted?: string;
    DurationDays: number;
    Id: string;
    NextId: string;
}

interface IPurchaseInfoProductDto {
    NumberOfIssues: number;
    IsUnlimitedIssues: boolean;
    IsAutoRenewable: boolean;
    IsPopularChoice: boolean;
    FormattedIssueDate: string;
    SubscriptionMaxMonitoringAlerts: number;
    SubscriptionMaxAutoDelivery: number;
    SubscriptionBackIssues: number;
    SubscriptionIssues: number;
    SubscriptionAdditionalIssueFormattedPrice: string;
    FormattedPrice: string;
    Price: IPurchaseInfoPriceDto;
    Name: string;
    Type: PurchaseInfoProductTypeDto;
    Id: string;
    Title?: string;
    Description?: string;
    Features?: string[];
    PromoInfo: IPurchaseInfoPromoInfoDto;
    NextSubscription: IPurchaseInfoProductDto;
    Period: IPurchaseInfoPeriodDto;
    isTrialSubscription?: boolean;
}

interface IPurchaseInfoIssueDto {
    IssueId: string;
    PublicationName: string;
    IssueDate: string;
    CouldPotentiallyBeRead: boolean;
}

interface IPurchaseInfoBillingInfoDto {
    AddressLine1: string;
    AddressLine2: string;
    CardName: string;
    CardholderName: string;
    CardRightDigits: string;
    City: string;
    RegionName: string;
    RegionCode: string;
    CountryName: string;
    CountryCode: string;
    PostalCode: string;
}

interface IPurchaseInfoDto {
    CurrentSubscriptionProductId: string;

    AllProducts: IPurchaseInfoProductDto[];
    Products: IPurchaseInfoProductDto[];
    BillingInfo: IPurchaseInfoBillingInfoDto;
    Bundles: IPurchaseInfoProductDto[];

    IssueInfo: IPurchaseInfoIssueDto;
}

interface IPurchaseProductsDto {
    singleIssueProduct: IPurchaseInfoProductDto | undefined;
    premiumProduct: IPurchaseInfoProductDto | undefined;
    selectProduct: IPurchaseInfoProductDto | undefined;
    singleTitleProduct: IPurchaseInfoProductDto;
}

interface IPurchaseRequest {
    articleId?: number;
    issueId?: string;
    promoCode?: string;
}

interface IPurchaseProductRequest {
    id: string;
    issue?: string;
    articleId?: string;
    cid?: string;
    type?: PurchaseInfoProductTypeDto;
    promoCode?: string;
}

interface IPurchaseDataDto {
    affiliation: string;
    cardType: string;
    currency: string;
    items: IPurchaseItemDataDto[];
    tax: number;
    transactionId: string;
    value: number;
}

interface IPurchaseItemDataDto {
    id: string;
    name: string;
    brand?: string;
    category?: string;
    variant?: string;
    subTotal?: number;
    discount?: number;
    total?: number;
    quantity?: number;
    coupon?: string;
}

interface ReceiptItem {
    FormattedPrice: string;
    Price: number;
    IsIssue: boolean;
    IsSubscription: boolean;
    Name: string;
    OrderItems: unknown;
    ProductId: string;
    SupplierId: string | null;
    SupplierName: string | null;
    SupplyModelId: SupplyModel | null;
    Type: number;
}

interface CheckoutReceipt {
    BillingInfo: IPurchaseInfoBillingInfoDto;
    Currency: string;
    DateCreated: string;
    FormattedTotal: string;
    HideBillingInfo: boolean;
    Items: ReceiptItem[];
    PoNumber: string;
    Total: number;
    UserEmailAddress: string;
    UserFirstName: string;
    UserLastName: string;
}

interface CheckoutTransactionItem {
    Id: string;
    Name: string;
    Price: number;
    ProductId: string;
    Type: number;
}

interface CheckoutTransaction {
    Currency: string;
    Id: string;
    Items: CheckoutTransactionItem[];
    Revenue: number;
}
interface CheckoutResult {
    Receipt: CheckoutReceipt;
    Transaction: CheckoutTransaction;
}

interface CheckoutResponse {
    OrderId: string;
    Status: 'Approved' | 'Pending' | 'Declined' | 'Error';
    ChallengeUrl: string;
    Result: CheckoutResult;
    ErrorMessage: string;
}

interface ICheckoutRequest {
    promoCode?: string;
    reCaptchaToken?: string;
}

interface IConfirmRequest {
    orderId: string;
    promoCode: string;
    printSubscriber_Field1: string | null;
    printSubscriber_Field2: string | null;
}

export {
    CheckoutReceipt,
    CheckoutResponse,
    CheckoutResult,
    CheckoutTransaction,
    ICheckoutRequest,
    IConfirmRequest,
    IPurchaseContextDto,
    IPurchaseDataDto,
    IPurchaseInfoBillingInfoDto,
    IPurchaseInfoDto,
    IPurchaseInfoIssueDto,
    IPurchaseInfoPeriodDto,
    IPurchaseInfoPriceDto,
    IPurchaseInfoProductDto,
    IPurchaseInfoPromoInfoDto,
    IPurchaseItemDataDto,
    IPurchaseProductRequest,
    IPurchaseProductsDto,
    IPurchaseRequest,
    PurchaseInfoProductTypeDto,
    PurchaseInfoSubscriptuionType,
};
